import type { CosmicCategoryType } from '@/lib/cms/cosmic/types/CosmicProductType'
import { useDoesUserHaveActiveSubscription } from '@/lib/hooks/services/useDoesUserHaveActiveSubscription'
import useGlobalStore from '@/store/useGlobalStore'

type Props = {
  categories?: CosmicCategoryType[]
}

export const useExclusiveProduct = ({ categories }: Props = {}) => {
  const {
    app: {
      marketExceptions,
      addProductToSubscription: { userHasActiveSubscription },
    },
    user: { customerType },
  } = useGlobalStore()

  const isExclusiveProduct =
    categories?.find((categoryData) => categoryData.slug === 'unicity-labs') ??
    false

  const { isLoadingHasActiveSubscription } = useDoesUserHaveActiveSubscription()

  // Qualified if the user has an active subscription or is an employee or family member
  const isQualifiedForExclusiveProducts =
    userHasActiveSubscription ||
    customerType === 'Employee' ||
    customerType === 'Family'

  const willShowUnlockedProductFlow =
    (isExclusiveProduct &&
      isQualifiedForExclusiveProducts &&
      marketExceptions?.isUlabsAvailable) ||
    !isExclusiveProduct

  return {
    willShowUnlockedProductFlow,
    isExclusiveProduct,
    isQualifiedForExclusiveProducts,
    isLoadingHasActiveSubscription,
  }
}
